module.exports = __webpack_public_path__ + "img/rozar.04b60342.png";